import React, { useState, useEffect } from 'react';
import './StaticControls.css';

const StaticControls = () => {
  const [intensity, setIntensity] = useState(0.6);
  const [speed, setSpeed] = useState(100);
  const [grain, setGrain] = useState(2);
  const [blackLevel, setBlackLevel] = useState(50);
  const [bandSpeed, setBandSpeed] = useState(1.5);
  const [isRunning, setIsRunning] = useState(true);

  // Get reference to the static generator from window (if it exists)
  const getStaticGenerator = () => window.staticGenerator;

  useEffect(() => {
    const generator = getStaticGenerator();
    if (generator) {
      generator.intensity = intensity;
    }
  }, [intensity]);

  useEffect(() => {
    const generator = getStaticGenerator();
    if (generator) {
      generator.speed = speed;
    }
  }, [speed]);

  useEffect(() => {
    const generator = getStaticGenerator();
    if (generator) {
      generator.grainSize = grain;
    }
  }, [grain]);

  useEffect(() => {
    const generator = getStaticGenerator();
    if (generator) {
      generator.blackLevel = blackLevel;
    }
  }, [blackLevel]);

  useEffect(() => {
    const generator = getStaticGenerator();
    if (generator) {
      generator.bandSpeed = bandSpeed;
      // Update existing bands' speeds
      if (generator.bands) {
        generator.bands.forEach(band => {
          const baseSpeedRatio = Math.random() * 2 + 0.5;
          band.speed = baseSpeedRatio * bandSpeed;
        });
      }
    }
  }, [bandSpeed]);

  const toggleStatic = () => {
    const generator = getStaticGenerator();
    if (generator) {
      if (isRunning) {
        generator.pause();
        setIsRunning(false);
      } else {
        generator.resume();
        setIsRunning(true);
      }
    }
  };

  return (
    <div className="controls">
      <div className="control-group">
        <label htmlFor="intensity">Static Intensity</label>
        <input
          type="range"
          id="intensity"
          min="0.1"
          max="1"
          step="0.1"
          value={intensity}
          onChange={(e) => setIntensity(parseFloat(e.target.value))}
        />
      </div>

      <div className="control-group">
        <label htmlFor="speed">Animation Speed</label>
        <input
          type="range"
          id="speed"
          min="50"
          max="300"
          step="50"
          value={speed}
          onChange={(e) => setSpeed(parseInt(e.target.value))}
        />
      </div>

      <div className="control-group">
        <label htmlFor="grain">Grain Size</label>
        <input
          type="range"
          id="grain"
          min="1"
          max="4"
          step="1"
          value={grain}
          onChange={(e) => setGrain(parseInt(e.target.value))}
        />
      </div>

      <div className="control-group">
        <label htmlFor="blackLevel">Black Level</label>
        <input
          type="range"
          id="blackLevel"
          min="0"
          max="100"
          step="5"
          value={blackLevel}
          onChange={(e) => setBlackLevel(parseInt(e.target.value))}
        />
      </div>

      <div className="control-group">
        <label htmlFor="bandSpeed">Band Speed</label>
        <input
          type="range"
          id="bandSpeed"
          min="0.1"
          max="20"
          step="0.1"
          value={bandSpeed}
          onChange={(e) => setBandSpeed(parseFloat(e.target.value))}
        />
      </div>

      <button className="toggle-button" onClick={toggleStatic}>
        {isRunning ? 'Pause Static' : 'Resume Static'}
      </button>
    </div>
  );
};

export default StaticControls;